// ProtectedRoute.js
import { Navigate, Outlet, useLocation } from "react-router";
import Spinner from "react-bootstrap/Spinner";
import { useAuth } from "./AuthContext";
import { ConfigProvider } from "./ConfigContext";
import MyNavbar from "./MyNavbar";
import { useState } from "react";
import BrowserNotifications from "./BrowserNotifications";

export default function ProtectedRoute({ allowedRoles }) {
   const { user, loading } = useAuth();
   const location = useLocation();

   if (loading)
      return (
         <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
         </Spinner>
      );

   if (!user) {
      return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
   }

   if (allowedRoles && !allowedRoles.includes(user.role)) {
      return <Navigate to="/test" replace />;
   }

   return (
      <ConfigProvider>
         <MyNavbar user={user} />
         <BrowserNotifications />
         <Outlet />
      </ConfigProvider>
   );
}
